import React from "react";
import GlobalSearch from "../../../components/Search";
import StatusFilter from "./StatusFilter";

function Filters() {
  return (
    <div className="tickets-filter d-flex justify-content-space-between bg-white">
      <GlobalSearch />
      <StatusFilter />
    </div>
  );
}

export default Filters;
